import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ExpandArrow from "../buttons/ExpandArrow";
import rightArrowIcon from '../../icons/rightArrow.svg';

const Menu = (props) => {
    const [items, setItems] = useState(props.items);
    const navigate = useNavigate();
    const toggleItem = (item, index, isOpen) => {
        if (!item.children) {
            navigate(item.location);
        } else {
            setItems((prev) => {
                var result = [...prev];
                result[index].isOpen = isOpen;
                return result;
            });
        }
    };
    const renderItems = () => {
        return items.map((item, index) => {
            return (
                <div className={'marginTop1 ' + (props.depth === 0 ? 'marginLeft2 marginRight2' : 'marginLeft2')}>
                    <div className='flexCenterV'>
                        <div onClick={() => toggleItem(item, index, !item.isOpen)}>{item.title}</div>
                        {item.children && <ExpandArrow className='flexEnd' white isExpanded={item.isOpen} onToggleExpanded={(isOpen) => toggleItem(item, index, isOpen)}></ExpandArrow>}
                        {!item.children && <img alt='' className='flexEnd' src={rightArrowIcon}></img>}
                    </div>
                    {item.isOpen && <Menu depth={props.depth + 1} items={item.children}></Menu>}
                    {!(props.depth > 0 && index === items.length - 1) &&< div className="afterBorder0"></div>}
                </div>
            );
        });
    };
    return (
        <div className={'darkBlueBg fs125 letterSpacing01 ' + (props.depth === 0 ? 'paddingTop1 overflowHidden minHeight100' : '')}>
            {renderItems()}
        </div>
    );
};

export default Menu;